<template>
    <v-main>
        <div class="center">
            <img src="@/assets/image/LOGO_machi.png" class="home-logo" />
        </div>
        <div>
            <p class="concept-balloon" v-text="conceptText"></p>
        </div>
        <!-- 3枚の写真横並び -->
        <div>
            <ul class="home_list">
                <li>
                    <div class="disable">
                        <router-link to="">
                            <img src="@/assets/image/Home/li1.png" height="100px" />
                            <p>
                                ゲストハウス
                                <br />
                                たびのきおく
                            </p>
                        </router-link>
                    </div>
                    <div class="homeCard">
                        <p>計画中</p>
                    </div>
                </li>
                <li>
                    <div class="disable">
                        <router-link to="">
                            <img src="@/assets/image/Home/li2.png" height="100px" />
                            <p>カフェ</p>
                        </router-link>
                    </div>
                    <div class="homeCard">
                        <p>計画中</p>
                    </div>
                </li>
                <li>
                    <div>
                        <router-link to="Consultant" active-class="current">
                            <img src="@/assets/image/Home/li3.png" height="100px" />
                            <p>
                                まちづくり
                                <br />
                                コンサルタント
                            </p>
                        </router-link>
                    </div>
                </li>
            </ul>
        </div>
        <div style="margin-top: 5px">
            <img class="img_pad" src="@/assets/image/Home/homeImg1.png" width="100%" />
        </div>
        <div style="margin: 5px 0px">
            <img class="img_pad" src="@/assets/image/Home/homeImg1_211.png" width="100%" />
        </div>
        <span class="tinydescription">
            <div>
                <p class="center" v-text="philosophyDescription"></p>
            </div>
        </span>
        <v-spacer style="margin: 50px"></v-spacer>
        <!-- イベント -->
        <div data-scroll-target="events" class="body-title">
            <p>
                イベント・お知らせ
                <br />
                Events・News
            </p>
        </div>
        <v-spacer style="margin: 15px"></v-spacer>
        <div>
            <span v-for="item in news" :key="item.YearMonthDay">
                <div class="about-inline about-inline-left"></div>
                <div class="about-inline about-inline-middle">
                    <p v-text="item.YearMonthDay"></p>
                </div>
                <div class="about-inline about-inline-right">
                    <router-link v-if="item.Detail" :to="{ name: 'NewsDetail', query: { date: item.YearMonthDay } }">
                        <p style="margin-right: 12%" v-text="item.Content" @click="NewsClick(item)"></p>
                    </router-link>
                    <p v-else style="margin-right: 12%" v-text="item.Content"></p>
                </div>
                <v-spacer style="margin: 5px"></v-spacer>
            </span>
        </div>
        <v-spacer style="margin: 40px"></v-spacer>
        <!-- 会社情報 -->
        <div data-scroll-target="about" class="body-title">
            <p>
                会社情報
                <br />
                About us
            </p>
        </div>
        <span>
            <v-spacer style="margin: 15px"></v-spacer>
            <div class="about-inline about-inline-left"></div>
            <div class="about-inline about-inline-middle">
                <p>会社名</p>
            </div>
            <div class="about-inline about-inline-right">
                <p v-text="companyName"></p>
            </div>
        </span>
        <span>
            <v-spacer style="margin: 15px"></v-spacer>
            <div class="about-inline about-inline-left"></div>
            <div class="about-inline about-inline-middle">
                <p>所在地</p>
            </div>
            <div class="about-inline about-inline-right">
                <p>新潟県新潟市</p>
            </div>
        </span>
        <span>
            <v-spacer style="margin: 15px"></v-spacer>
            <div class="about-inline about-inline-left"></div>
            <div class="about-inline about-inline-middle">
                <p>事業内容</p>
            </div>
            <div class="about-inline about-inline-right">
                <p v-text="businessdetails"></p>
            </div>
        </span>
        <span>
            <v-spacer style="margin: 15px"></v-spacer>
            <div class="about-inline about-inline-left"></div>
            <div class="about-inline about-inline-middle">
                <p>代表者名</p>
            </div>
            <div class="about-inline about-inline-right">
                <p>成川優花</p>
            </div>
        </span>
        <span>
            <v-spacer style="margin: 15px"></v-spacer>
            <div class="about-inline about-inline-left"></div>
            <div class="about-inline about-inline-middle">
                <img src="@/assets/image/Home/yuka.jpg" width="100%" style="padding-right: 10px; max-width: 200px" />
            </div>
            <div class="about-inline about-inline-right">
                <p v-text="profile"></p>
            </div>
        </span>
        <span>
            <v-spacer style="margin: 15px"></v-spacer>
            <div class="about-inline about-inline-left"></div>
            <div class="about-inline about-inline-middle">
                <p>設立年月</p>
            </div>
            <div class="about-inline about-inline-right">
                <p>2024年10月30日</p>
            </div>
        </span>
        <v-spacer style="margin: 50px"></v-spacer>
        <!-- 問い合わせ -->
        <div data-scroll-target="contact" class="body-title">
            <p>
                問い合わせ
                <br />
                Contact
            </p>
        </div>
        <span>
            <v-spacer style="margin: 15px"></v-spacer>
            <div class="contact-inline contact-inline-left">
                <p>email：</p>
            </div>
            <div class="contact-inline contact-inline-right">
                <p>machitabi.d(@)gmail.com</p>
            </div>
            <div class="contact-inline contact-inline-left">
                <p>Instagram：</p>
            </div>
            <div class="contact-inline contact-inline-right">
                <p>@yuka2700</p>
            </div>
        </span>
    </v-main>
</template>

<script>
// News.jsonを公開ディレクトリから読み込む（相対パス）
const url = './assets/News.json'

export default {
    data: () => ({
        conceptText: 'まち×たびで世界を広げるサポートを。',
        companyName: '合同会社まちたびデザイン\r\nMachitabi Design LLC.',
        businessdetails:
            'ゲストハウス(計画中)\r\nカフェ(計画中)\r\nまちづくりコンサルタント',
        philosophyDescription:
            '合同会社まちたびデザインは\r\n代表が世界一周をして感じた世界の魅力を\r\n子どもたちに身近に感じて世界へ興味を持ってもらいたい\r\n旅人たちの交流の場となり世界中を旅するきっかけを作りたい\r\nそして、改めて知った日本・新潟の魅力(食・文化・景色等)を\r\n世界中を旅する人にもっと知ってもらいたい\r\n新潟の魅力を知った人たちが帰国後に\r\n世界に羽ばたき発信する側となってもらいたい\r\n地元の人にももっと魅力を知ってもらいたい\r\nまちの魅力を高めもっと新潟を元気にしたい\r\nそんな壮大な想いから\r\nゲストハウス×カフェ×まちづくりコンサルタント\r\nの3つの軸で活動できるように立ち上げました。\r\n\r\n新潟でのまちづくりを通じて旅人・地元の人の交流ができ\r\n暮らす人も旅をしているような\r\nわくわくする感覚で地元の魅力を発見できる\r\nそんな世界を広げるサポートをしたいと考えています。\r\n\r\nゲストハウス、カフェは物件を探し中です。\r\nご興味のある方はぜひ一度ご連絡ください。',
        news: null,

        profile:
            '岐阜県多治見市出身 \r\n新卒で建設コンサルタント会社に就職\r\n7年間公園や公共空間の計画設計をメインに\r\n住民主体のまちづくりを実施\r\n技術士(建設部門・都市及び地方計画)を取得\r\n退社後に7ヶ月間の世界一周ひとり旅を経験\r\n帰国後に合同会社まちたびデザインを設立',

        newsDetailDialog: false,
    }),

    async mounted() {
        await fetch(url)
            .then((res) => res.json())
            .then((res) => (this.news = res))
    },

    methods: {
        // お知らせの詳細をセッションストレージに保存
        NewsClick(item) {
            sessionStorage.removeItem('NewsItem')
            sessionStorage.setItem('NewsItem', JSON.stringify(item))
        },
    },
}
</script>

<style scoped>
/* Home Page Styles */
.center {
    display: flex;
    justify-content: center;
    text-align: center;
}

.home-logo {
    width: 40%;
    margin-top: 20px;
}

.concept-balloon {
    text-align: center;
    position: relative;
    padding: 9px;
    background: #1b465b;
    font-size: 16px;
    font-weight: 100;
    color: #ffffff;
    border-radius: 5px;
    width: 83%;
    margin: 20px auto;
    white-space: pre-wrap;
}

.home_list {
    display: flex;
    list-style: none;
    justify-content: space-evenly;
    text-align: center;
}

.home_list li {
    width: 33%;
    margin: 0% 1% 0% 1%;
    position: relative;
}

.homeCard {
    position: absolute;
    top: 0%;
    opacity: 0.7;
    border-radius: 20px;
    height: 100%;
    width: 100%;
    background-color: #1b465b;
    color: #ffffff;
    display: flex;
    text-align: center;
    justify-content: center;
}

.homeCard p {
    margin: auto;
}

.img_pad {
    padding: 0px 15px;
}

.tinydescription {
    padding: 0px;
    margin: 0px;
    font-size: 12px;
    white-space: pre-wrap;
}

.tinydescription div {
    display: flex;
    justify-content: center;
    text-align: center;
}

@media screen and (min-width: 760px) {
    .home-logo {
        width: 25%;
    }

    .tinydescription {
        padding: 0px;
        margin: 0px;
        font-size: 20px;
        white-space: pre-wrap;
    }
}
</style>
